/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Ai_ReplyInputs */

const en_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft AI Reply`)
};

const es_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador de respuesta IA`)
};

const fr_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon de réponse IA`)
};

const de_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Antwort entwerfen`)
};

const ja_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI返信を下書きする`)
};

const zh_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起草 AI 回复`)
};

const ar_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صياغة رد بواسطة الذكاء الاصطناعي`)
};

const id_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf Balasan AI`)
};

const it_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza di Risposta IA`)
};

const ru_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовить ответ (ИИ)`)
};

const pt_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho de Resposta IA`)
};

const ko_draft_ai_reply = /** @type {(inputs: Draft_Ai_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI로 답장 초안 작성`)
};

/**
* | output |
* | --- |
* | "Draft AI Reply" |
*
* @param {Draft_Ai_ReplyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const draft_ai_reply = /** @type {((inputs?: Draft_Ai_ReplyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Ai_ReplyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_ai_reply(inputs)
	if (locale === "es") return es_draft_ai_reply(inputs)
	if (locale === "fr") return fr_draft_ai_reply(inputs)
	if (locale === "de") return de_draft_ai_reply(inputs)
	if (locale === "ja") return ja_draft_ai_reply(inputs)
	if (locale === "zh") return zh_draft_ai_reply(inputs)
	if (locale === "ar") return ar_draft_ai_reply(inputs)
	if (locale === "id") return id_draft_ai_reply(inputs)
	if (locale === "it") return it_draft_ai_reply(inputs)
	if (locale === "ru") return ru_draft_ai_reply(inputs)
	if (locale === "pt") return pt_draft_ai_reply(inputs)
	return ko_draft_ai_reply(inputs)
});